import { Css } from "@homebound/beam";
import { getCompanyInfoField } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/utils/companyInfoUtils";
import { CompanyInfoFieldFragment } from "../CommitmentOrChangeOrderPdf/utils/companyInfoUtils.generated";
import { Section } from "./Section";

type BidCommitmentTermsProps = {
  project?: CompanyInfoFieldFragment;
};

export function BidCommitmentTerms({ project }: BidCommitmentTermsProps) {
  return (
    <Section title="Terms and Conditions">
      <div css={Css.mb2.$}>
        <ol>
          <li>
            INCORPORATION. This Purchase Order (“PO”) is issued pursuant to and hereby made a part of the Master Service
            Agreement (“Agreement”), between {getCompanyInfoField(project, "name")} (“Homebound”) and entity or
            individual (“Trade Partner”). This PO incorporates herein by reference all the definitions, terms, and
            conditions of the Agreement as though set forth in full herein.
          </li>
          <li>
            CONTRACT DOCUMENTS. The Contract Documents for this PO are enumerated below and incorporated herein by
            reference.
            <ol type="a">
              <li>This PO;</li>
              <li>The Agreement, including all amendments thereto;</li>
              <li>The Project Specific Agreement ("PSA"); If applicable</li>
              <li>The Trade Partner Price Agreement; If applicable</li>
              <li>Any applicable Plans and Specifications as listed within this PO</li>
              <li>Any other documents listed as a “Contract Document” in the Agreement</li>
            </ol>
          </li>
          <li>
            PAYMENT. Trade Partner must submit application for payment in the means and manner requested by Homebound.
            No payment made hereunder shall be considered an acceptance of the Work in whole or in part, or a waiver of
            any rights or remedies to which Homebound is entitled.
          </li>
          <li>
            SCHEDULE. The relevant milestones, completion dates, and terms associated with this PO may be included in
            this PO or determined by Homebound at a later date.
          </li>
        </ol>
      </div>
    </Section>
  );
}
